module.exports = __webpack_public_path__ + "img/nicetohave-product-design-06.9f90a313.jpg";